// extracted by mini-css-extract-plugin
export var insideHeading = "news-v2-module--insideHeading--1692e";
export var newsBlock = "news-v2-module--newsBlock--0d202";
export var newsFooter = "news-v2-module--newsFooter--e405d";
export var newsHeading = "news-v2-module--newsHeading--25336";
export var newsItem = "news-v2-module--newsItem--9746a";
export var subHead = "news-v2-module--subHead--228e2";